﻿import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { CrudFunctions } from '../../utilities/crud-functions';
import { AnalyticalPlanListItem } from '../../models/AnalyticalPlans/analytical-plan-list-item';
import { Entities, ModalMessageType } from '../../models/enums';
import { ItemBasicInformation } from '../../models/item-basic-information';
import AuditHistoryComponent from '../AuditHistoryComponent';
import ItemBasicInformationDialog from '../ItemBasicInformationDialog';
import { ModalMetadata } from '../../models/modal-metadata';
import GlobalDialog from '../Modal/GlobalDialog';

import DataGrid, {
    Column,
    Paging,
    Toolbar,
    Selection,
    Item as ToolbarItem
} from 'devextreme-react/data-grid';

import { Popup as DialogPopup } from 'devextreme-react/popup';
import Button from 'devextreme-react/button';

let key = 0;

export interface Props {
    productId: string;
    isReadOnly: boolean;
}

export default function BatchAnalyticalPlansComponent(props: Props) {
    const [analyticalPlanTechnologies, setAnalyticalPlanTechnologies] =
        useState<AnalyticalPlanListItem[]>();

    const [itemBasicInformation, setItemBasicInformation] =
        useState<ItemBasicInformation>();

    const [itemBasicInformationDialogVisible, setItemBasicInformationDialogVisible] =
        useState<boolean>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>()

    useEffect(() => {
        getAllData()
    }, [props.productId]);

    key++;

    return (
        <div>
            <div>
                <DataGrid
                    height='14rem'
                    wordWrapEnabled={true}
                    allowColumnResizing={true}
                    keyExpr="analyticalPlanId"
                    columnResizingMode="nextColumn"
                    dataSource={analyticalPlanTechnologies ? analyticalPlanTechnologies : []}
                    rowAlternationEnabled={true}
                    showRowLines={true}
                    showBorders={true}>

                    <Selection mode='single' />
                    <Paging enabled={false} />

                    <Column dataField='technologyName' caption="Technology" width="10rem" dataType="string" />
                    <Column dataField='methodDescription' width="20rem" dataType="string" />
                    <Column dataField='scopesTypeNamesList' caption="Scope Types" dataType="string" />

                    <Toolbar>
                        <ToolbarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">Analytical Plan Technologies</div>
                            </div>
                        </ToolbarItem>
                    </Toolbar>

                </DataGrid>

            </div>

            {itemBasicInformationDialogVisible &&
                <DialogPopup visible={itemBasicInformationDialogVisible}
                    onHiding={hideItemBasicInformationDialog}
                    title="Item Basic Information"
                    width={'25rem'}
                    height={'21rem'}
                    dragEnabled={false}
                    resizeEnabled={false}>
                    <ItemBasicInformationDialog initInformation={itemBasicInformation}
                        onOkClick={hideItemBasicInformationDialog}
                        key={`IBI${key}`} />
                </DialogPopup>
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }

        </div>
    );


    async function getProductAnalyticalPlanTechnologies() {
        await CrudFunctions.getData(`analyticalplans/productanalyticalplantechnologies/${props.productId ? props.productId : undefined}`)
            .then(data => {
                setAnalyticalPlanTechnologies(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Analytical Plan Technologies");
            });
    }


    async function getAllData() {
        await Promise.all([
            getProductAnalyticalPlanTechnologies()
        ]);
    }

    //render

    function onStandardInformationButtonClicked(e: any) {
        if (e.row && e.row.data) {
            let itemInformation: ItemBasicInformation = {
                rowPointer: e.row.data.productStandardId,
                createTimestamp: e.row.data.createTimestamp,
                lastModifiedTimestamp: e.row.data.modifyTimestamp,
                createUser: e.row.data.createUser,
                modifyUser: e.row.data.modifyUser
            };

            setItemBasicInformation(itemInformation);
            setItemBasicInformationDialogVisible(true);
        }
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function hideItemBasicInformationDialog() {
        setItemBasicInformationDialogVisible(false);
    }


}